import { render, staticRenderFns } from "./trainRecord.vue?vue&type=template&id=a8fea448&scoped=true&"
import script from "./trainRecord.vue?vue&type=script&lang=ts&"
export * from "./trainRecord.vue?vue&type=script&lang=ts&"
import style0 from "./trainRecord.vue?vue&type=style&index=0&id=a8fea448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fea448",
  null
  
)

export default component.exports